import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function ProtectedRoute() {
  const { user, loading } = useAuth();

  // Show a loading message while checking authentication
  if (loading) {
    return (
      <main style={{
        padding: '2rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '80vh'
      }}>
        <h2>Loading...</h2>
      </main>
    );
  }

  // If the user is authenticated, render the child route.
  if (user) {
    return <Outlet />;
  }

  // If the user is not authenticated, redirect to the login page.
  return <Navigate to="/login" replace />;
}
